<template>
    <div class="AdminChatWrapper">


        <div id="AdminChat" class="adminChat">

            <div class="container bg-light">
                <div class="row">

                    <!-- USER LIST CONTAINER -->
                    <div class="col-md-4 pr-1">

                        <div class="card memberlist-panel mt-2">
                            <div class="card-header">
                                Users
                                <div class="float-right">                               
                                     <span class="primary-outline" v-b-modal.createNewMessage>
                                        <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
                                     </span>
                                </div>                            
                            </div>
                            
                            <div class="card-body" ref="userListBody" @scroll="onUserListScroll" @wheel="onUserListWheel">

                                <div v-for="user in visibleUsers" :key="'user_'+ user.userid" v-on:click="openChatBox(user)" >

                                    <div class="user-list">

                                        <div :class="[user.userid == activeUserID ? 'active' : '', 'user-info']">
                                            <div class="profile-photo align-top">
                                                <img :src="user.user_image" class="user-list-photo" alt="">
                                            </div>

                                            <div class="profile-user-info align-bottom">

                                                <div class="nickname small font-weight-bold">{{ user.nickname }}</div>
                                                <div class="user-list-email">
                                                    <span class="username small text-secondary">{{ user.username }}</span>
                                                    <span v-if="user.recentAt" class="user-list-date">{{ formatRecentAt(user.recentAt) }}</span>
                                                </div>
                                                <div class="admin-presence" :class="presenceClass(user)">{{ presenceLabel(user) }}</div>
                                                <div id="user-recent-message" class="user-list-recent small text-secondary">
                                                    <i v-if="recentIcon(user.recentKind)" :class="recentIcon(user.recentKind)" aria-hidden="true"></i>
                                                    <span>{{ user.recentMsg }}</span>
                                                </div>


                                                <div class="small float-left ml-1">
                                                    <span id="message_counter" class="badge badge-danger small" v-if="user.unreadMsg > 0" >
                                                        {{ user.unreadMsg }}
                                                    </span>
                                                </div>
                                            </div>

                                        </div>

                                    </div>


                                </div>
                            </div>

                            <div class="user-list-status">
                                <div v-if="userListLoading" class="admin-chat-older-btn admin-chat-loader" aria-live="polite">
                                    <i class="fas fa-sync fa-spin" aria-hidden="true"></i>
                                    <span>Loading</span>
                                </div>
                                <div v-else class="user-list-count" aria-live="polite">{{ userListCountLabel }}</div>
                            </div>
                        </div>
                    </div>
                    <!-- [end] USER LIST -->

                    <div class="col-md-8 pl-1">
                        <div class="chatbox mt-2">    

                            <div v-if="this.current_user !== null">
                            
                                <!--[start] card -->
                                <div class="card">

                                   <!--[start] User Information Header -->
                                    <current-user-component :user="this.current_user" :typing="isMemberTyping(current_user)"></current-user-component>
                                    <!--[end] User Information Header -->

                                    <!-- Chat Log Information Header -->
                                    <div class="card-body">

                                        <div v-if="isLoading == true" class="loading-container text-center">
                                            <div class="admin-chat-older-btn admin-chat-loader">
                                                <i class="fas fa-sync fa-spin" aria-hidden="true"></i>
                                                <span>Loading</span>
                                            </div>
                                        </div>
                                        <div id="user-chatlog" class="admin-chat-log" :key="'thread-' + activeUserID" v-else-if="isLoading == false" @scroll="handleScroll" @click="onChatImageClick"> 


                                            <div class="admin-chat-older" v-show="historyNotifier == true"> 
                                                <button type="button" class="admin-chat-older-btn" v-on:click="showPreviousMessages" v-show="isFetching == false">
                                                    <i class="fas fa-clock"></i> View previous message
                                                </button>
                                                <div v-show="isFetching == true" class="admin-chat-older-btn admin-chat-loader">
                                                    <i class="fas fa-sync fa-spin" aria-hidden="true"></i>
                                                    <span>Loading</span>
                                                </div>
                                            </div>                                


                                            <chatlogs-component :key="'hist-' + activeUserID" :chatlogs="chatlogsHistory" :latest-message-id="latestEditableId" :latest-deletable-id="latestDeletableId" :now="editClock" :editing-id="editingMessageId"></chatlogs-component>
                                            <div v-if="chatlogsUnread.length >= 1" class="admin-chat-unread-separator" role="separator">
                                                <span>Unread</span>
                                            </div>
                                            <chatlogs-component v-if="chatlogsUnread.length >= 1" :key="'unread-' + activeUserID" :chatlogs="chatlogsUnread" :latest-message-id="latestEditableId" :latest-deletable-id="latestDeletableId" :now="editClock" :editing-id="editingMessageId"></chatlogs-component>
                                            <chatlogs-component v-if="chatlogs.length >= 1" :key="'live-' + activeUserID" :chatlogs="chatlogs" :latest-message-id="latestEditableId" :latest-deletable-id="latestDeletableId" :now="editClock" :editing-id="editingMessageId"></chatlogs-component>
                                            <div v-for="item in outbox" :key="item.clientId" class="admin-chat-msg is-support is-unsent">
                                                <span class="admin-chat-avatar"><i class="fas fa-headset"></i></span>
                                                <div class="admin-chat-body">
                                                    <div class="admin-chat-bubble chatsupport-message is-failed" v-html="formatOutboxMessage(item.message)"></div>
                                                    <div class="admin-chat-unsent">
                                                        <span>Not sent</span>
                                                        <button type="button" class="admin-chat-resend" :disabled="!!resendingIds[item.clientId]" @click="resendOutbox(item)">
                                                            {{ resendingIds[item.clientId] ? 'Sending...' : 'Resend' }}
                                                        </button>
                                                        <button type="button" class="admin-chat-discard" :disabled="!!resendingIds[item.clientId]" @click="discardOutbox(item)">
                                                            Delete
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>


                                        <div id="attached-progress-report" class="mt-2" >
                                            <div v-for="(file, index) in files" :key="file.id" style="display:inline-block; padding:5px; " class="image-prieview-container">

                                                <div class="remove-image-upload" style="float:right;">
                                                    <a class="" href="#" @click.prevent="$refs.upload.remove(file)" style="padding:5px; background-color:#fff; color:#000">X</a>
                                                </div>

                                                <img v-if="file.type == 'image/jpeg' || file.type == 'image/png'" :src="file.thumb" style="width:150px" :id="'image-preview-'+index">  
                                                <div v-else>
                                                    <div>
                                                        <i class="far fa-file" style="font-size:110px"></i>
                                                    </div>
                                                </div>

                                                <div class="progress" v-if="file.active || file.progress !== '0.00'">
                                                    <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}" role="progressbar" :style="{width: file.progress + '%'}">{{file.progress}}%</div>
                                                </div>

                                            </div>                                                                               
                                        </div>


                                        <div v-if="sendError" class="admin-chat-send-error" role="alert">{{ sendError }}</div>
                                        <div v-if="messageActionError" class="admin-chat-send-error" role="alert">{{ messageActionError }}</div>
                                        <div class="admin-chat-composer" :class="{ 'is-editing': !!editingMessageId }">
                                            <div class="text-message-container">
                                                <TextareaAutosize
                                                    id="message"
                                                    ref="messageTextarea"
                                                    :min-height="30"
                                                    :max-height="55"
                                                    autocomplete="off"
                                                    class="form-control form-control-sm auto-expand"
                                                    v-model="message"
                                                    :placeholder="editingMessageId ? 'Edit message' : 'Type a message'"
                                                    aria-label="Type a message"
                                                    @input="onComposerActivity"
                                                />
                                            </div>
                                            <div class="admin-chat-composer-actions">
                                                <button v-if="editingMessageId" type="button" class="admin-chat-cancel-edit" @click="cancelEditMessage">
                                                    <i class="fas fa-times" aria-hidden="true"></i>
                                                    <span>Cancel</span>
                                                </button>
                                                <div id="attach-button" class="input-group-append">
                                                    <label id="file-select-button" for="file" class="icon-label-container btn btn-primary btn-sm mb-0">
                                                        <i class="fas fa-paperclip icon-label-btn"></i>
                                                    </label>
                                                </div>
                                                <div id="send-button" class="input-group-append">
                                                    <label :id="'btn_'+ current_user.userid" class="icon-label-container btn btn-primary btn-sm mb-0" @click.prevent="$refs.upload.active = false; sendMessage(); ">
                                                        <i class="fa fa-paper-plane icon-label-btn" aria-hidden="true"></i>
                                                    </label>
                                                </div>
                                                <span class="button-controls" style="display:none">
                                                    <button id="startUpload" type="button" class="btn btn-sm btn-success" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
                                                        <i class="fa fa-arrow-up" aria-hidden="true"></i>Start Upload
                                                    </button>
                                                    <button type="button" class="btn btn-sm btn-danger" v-else @click.prevent="$refs.upload.active = false">
                                                        <i class="fa fa-stop" aria-hidden="true"></i>Stop Upload
                                                    </button>
                                                </span>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <!--[end] card -->




                            </div>


                        </div>
                    </div>

                </div>
            </div>


            <div style="display:none">
                <file-upload
                    name="file"
                    class="btn btn-primary"
                    extensions="jpeg,jpg,gif,pdf,png,webp"
                    accept="image/png, application/pdf, image/prigif, image/jpeg, image/webp"
                    v-model="files"
                    post-action="/uploader/fileUploader"            
                    :data="{ 
                        'message_type': 'CHAT_SUPPORT',
                        'current_chatbox_userid': this.activeUserID
                    }"
                    :headers="{'X-CSRF-TOKEN': this.csrf_token }"
                    :multiple="true"
                    :drop="true"
                    :drop-directory="true"
                    @input="updatetValue"
                    @input-file="inputFile"
                    @input-filter="inputFilter" ref="upload">      
                </file-upload>
            </div>


        </div>

        


        <div id="create-mesage-container">
            <!--[start] Modal Create New Message -->
            <b-modal id="createNewMessage" title="Create New Message" button-size="sm">

                <div id="member-select" class="small">
                    <multiselect                     
                        v-model="selectedMember" 
                        @select="onSelect"
                        id="multiselect-members" 
                        class="small"
                        label="name" 
                        track-by="name" 
                        placeholder="Type to search" 
                        open-direction="bottom" 
                        :options="members" 
                        :multiple="false" 
                        :searchable="true" 
                        :loading="isLoadingMembers" 
                        :internal-search="false" 
                        :clear-on-select="true" 
                        :close-on-select="true" 
                        :options-limit="300" 
                        :limit="1" 
                        :limit-text="limitText" :max-height="600" 
                        :show-no-results="true" 
                        :hide-selected="false" 
                        @search-change="findMember">

                        <template slot="singleLabel" slot-scope="{ option }">                        
                            <span class="small">{{ option.name }}</span>
                        </template>


                        <template slot="option" slot-scope="props">                        
                            <span class="option__desc small"><span class="option__title">{{ props.option.id}} {{ props.option.name}}</span></span>
                        </template>

                        <span slot="noResult">Oops! No Member found.</span>

                        <span slot="noOptions">Please search for a member</span>

                    </multiselect>
                    
                </div>



                <div class="outgoing-message mt-2">
                    <b-form-textarea id="outgoingMessage" v-model="outgoingMessage" placeholder="Enter Message..." rows="5" max-rows="2"></b-form-textarea>
                </div>

                <template #modal-footer>
                     <b-button size="sm" variant="primary" @click="sendNewMessage()">
                        <i aria-hidden="true" class="fa fa-paper-plane"></i> Send
                    </b-button>
                </template>
              
                <!--{{ this.selectedMember }}-->

            </b-modal>
            <!--[end] Modal Create New Message-->
        </div>

        <div v-if="imagePreview" class="admin-image-preview" tabindex="-1" ref="imagePreview" @click.self="closeImagePreview" @keydown.esc="closeImagePreview" @keydown.left.prevent="showPreviewImage(imagePreview.index - 1)" @keydown.right.prevent="showPreviewImage(imagePreview.index + 1)">
            <div class="admin-image-preview-dialog">
                <div class="admin-image-preview-frame">
                    <div class="admin-image-preview-bar">
                        <span class="admin-image-preview-name">{{ previewImage().name }}</span>
                        <span v-if="imagePreview.images.length > 1" class="admin-image-preview-count">{{ imagePreview.index + 1 }} / {{ imagePreview.images.length }}</span>
                        <a class="admin-image-preview-btn is-open" :href="previewImage().src" target="_blank" rel="noopener" title="Open in a new tab" aria-label="Open in a new tab"><i class="fas fa-external-link-alt"></i></a>
                        <a class="admin-image-preview-btn" :href="previewImage().src" :download="previewImage().name" title="Download" aria-label="Download"><i class="fas fa-download"></i></a>
                        <button type="button" class="admin-image-preview-btn" @click="closeImagePreview" title="Close" aria-label="Close"><i class="fas fa-times"></i></button>
                    </div>
                    <div class="admin-image-preview-stage">
                        <button v-if="imagePreview.images.length > 1" type="button" class="admin-image-preview-nav is-prev" @click="showPreviewImage(imagePreview.index - 1)" title="Previous" aria-label="Previous"><i class="fas fa-chevron-left"></i></button>
                        <img class="admin-image-preview-img" :src="previewImage().src" :alt="previewImage().name">
                        <button v-if="imagePreview.images.length > 1" type="button" class="admin-image-preview-nav is-next" @click="showPreviewImage(imagePreview.index + 1)" title="Next" aria-label="Next"><i class="fas fa-chevron-right"></i></button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import VueSocketIO from 'vue-socket.io';
import FileUpload from 'vue-upload-component'
import Multiselect from 'vue-multiselect'
import TextareaAutosize from 'vue-textarea-autosize'

Vue.use(new VueSocketIO({
    debug: false,
    connection: 'https://chatserver.mytutor-jpn.info:30001/',
}));

Vue.use(TextareaAutosize)



export default {
    name: "chatComponent",
    components: {
        FileUpload, Multiselect
    },  
    data() {
        return {
            adminUser : null,

            users: [],              // list for all users (online and offline)
            userListLimit: 7,       // users rendered in the side list; more load on scroll
            userListPageSize: 7,    // each recent-user request loads this many
            userListOffset: 0,      // next offset for getRecentUserChatList
            userListHasMore: true,  // false after a short page; no end-of-list message
            userListRequestId: 0,
            userListLoading: true,
            userListTotal: null,    // members with a real support conversation
            userListFillTimer: null,   // pending no-scrollbar fill; cleared on replace/destroy
            onlineUsers: [],        // list for online users
            recentUsers: [],        //the list recently messaged user (offline)            
            current_user: null,     //all info of current uses         
            activeUserID: null,     //this will hold the current active userid  

            chatlogsHistory: [],    //Old Read chats
            chatlogsUnread: [],     //Unread Chats
            chatlogs: [],           //live chat logs

            message: "",
            sendError: "",
            messageActionError: "",
            outbox: [],
            editingMessageId: null,
            typingMembers: {},
            typingExpiry: {},
            adminTypingActive: false,
            adminTypingSentAt: 0,
            adminTypingTimer: null,
            editDraft: "",
            editClock: Date.now(),
            editClockTimer: null,
            resendingIds: {},
            sendingText: false,

            typingTimer:"",             //timer for search user on outgong message
            outgoingMessage:"",     //outgoing message for user

            // Loaders
            isLoading: false,
            isLoadingMembers: false,
            historyNotifier: true,      //History Button Page notifier
            historyRequested: false,    //read history loads only after Previous messages
            threadRequestId: 0,         //drops chat fetches from a user you already left
            isFetching: false,          //history is fetching status
            attentionUsers: {},         //member chats that still need the tab blink

            //WINDOW STATUS FOR TAB TITLE BLINKER
            TabTitle: "",
            windowStatus: "FOCUSED",        
            interval: null,
            scrollInterval: "",
            isScrollActivated: false,
            tabTitle: "",

            //uploader
            files: [],
            imagePreview: null,
            page: [],

            //members
            selectedMember: [],
         
            members: []            
        };
    },
    props: {
        userid: String,
        username: String,
        nickname: String,
        api_token: String,    
        csrf_token: String,  
        chatserver_url: String,              
    },
    sockets: {
        update_user_list: function (users) {
            this.updateUserList(users);
        },
        CHAT_TYPING: function (data) {
            this.onRemoteTyping(data);
        },
        OWNER_MESSAGE: function (data) {


            if (data.broadcast_recipient.userid == this.userid) 
            {
                this.prepareChatBox(data.broadcast_recipient);

                let sender = {
                    'msgCtr': 1,
                    'userid': data.broadcast_sender.userid,
                    'username': data.broadcast_sender.username, 
                    'nickname':  "Customer Support",
                    'message': data.broadcast_sender.message,
                    'user_image': data.broadcast_sender.user_image,   
                    'type': data.broadcast_sender.type,          
                };

               
                if (this.current_user !== null && this.current_user.userid == data.broadcast_sender.userid) 
                {

                    console.log("owner message");

                    this.pushIncomingSupportLog(data.broadcast_sender.history_id || null, data.time, sender);
                    
                    this.$nextTick(function()
                    {
                       

                        if (this.current_user.userid == data.broadcast_sender.userid) {
                            console.log("scroll to end 1")
                
                            this.scrollToEnd();
                        }                        
                    });

                }

                
            } else {

                console.log("this is from other users");

                //reset unread message to 0

                if (data.broadcast_sender.type !== 'MEMBER') {

                    let userIndex = this.users.findIndex(user => user.userid == data.broadcast_sender.userid)

                    if (userIndex) {
                        this.users[userIndex].unreadMsg  = 0;  
                    }
                }                

                //log and simultainously show to other admin               
                if (data.broadcast_sender.userid == this.activeUserID) {

                    this.prepareChatBox(data.broadcast_sender);                 

                    let sender = {
                        'msgCtr': 1,
                        'userid': data.broadcast_sender.userid,
                        'username': data.broadcast_sender.username, 
                        'nickname':  "Customer Support",
                        'message': data.broadcast_sender.message,
                        'user_image': data.broadcast_sender.user_image,   
                        'type': data.broadcast_sender.type,          
                    };

            
                    this.pushIncomingSupportLog(data.broadcast_sender.history_id || null, data.time, sender);
                    this.$nextTick(function()
                    {

                        if (this.current_user.userid == data.broadcast_sender.userid) {

                            console.log("scroll to end 2")
                            this.scrollToEnd();
                        }                        
                    });

                }
            }	            
        }, 
        PRIVATE_MESSAGE: function(data) {
            var signal = this.readSupportEdit(data);
            if (signal) {
                if (this.current_user && data.recipient && String(this.current_user.userid) === String(data.recipient.userid)) {
                    if (signal.kind === "delete") {
                        this.removeThreadMessage(signal.historyId);
                    } else {
                        this.updateThreadMessage(signal.historyId, signal.message);
                    }
                }
                return;
            }


            this.prepareChatBox(data.sender);

            let sender = {
                'msgCtr': 1,
                'userid': data.sender.userid,
                'username': data.sender.username, 
                'nickname': data.sender.nickname,
                'message': data.sender.message,
                'user_image': data.sender.user_image,   
                'type': data.sender.type, 
            };
            


            if (this.current_user !== null && this.current_user.userid == data.sender.userid) {                

                //console.log("PRIVATE_MESSAGE");
                this.chatlogs.push({
                    time: data.time,
                    sentAt: new Date().toISOString(),
                    sender: sender            
                });
                this.$forceUpdate();
            }
 


            this.$nextTick(function() 
            {
                console.log("private message");

                var viewingThisChat = this.current_user
                    && String(this.current_user.userid) === String(data.sender.userid);

                if (viewingThisChat) {
                    this.scrollToEnd();
                }

                if (data.sender.type === "CHAT_SUPPORT") {
                    return;
                }

                // The tab keeps blinking until this member's chat is opened and read.
                if (viewingThisChat && this.windowStatus === "FOCUSED") {
                    this.clearUnreadAttention(data.sender.userid);
                } else {
                    this.noteUnreadAttention(data.sender.userid);
                    this.blink();
                }

            });             

            this.$nextTick(function()
            {
                //let chatMessage = this.users.find(user => user.userid == data.sender.userid);

                var length = 30;
                let string = data.sender.message                
                var trimmedString = string.length > length ? string.substring(0, length - 3) + "..." : string;
               

                let userIndex = this.users.findIndex(user => user.userid == data.sender.userid)

                if (this.users[userIndex]) 
                {
                    //USER SENDING A MESSAGE IS FOUND ON THE LIST OF USERS ONLINE
                    if (data.sender.type == "CHAT_SUPPORT") {

                        //chat support is sending a message to a member
                        //we don't need to increase the unread message counter since this counter is for unread message from member
                        var supportIndex = this.users.findIndex(user => user.userid == data.recipient.userid);
                        if (this.users[supportIndex]) {
                            this.applyRecentPreview(this.users[supportIndex], data.sender.message);
                            this.users.unshift(this.users.splice(supportIndex, 1)[0]);
                        }

                        //this.markSeenMessages() //marked as read relegated to when a chat support reply to messages only

                    } else {

                        //Member message is recieved, increase to message counter by 1
                        //console.log("Private chat message + indexed for new user")

                      
                        if (isNaN(this.users[userIndex].unreadMsg)) {
                            this.users[userIndex].unreadMsg = 1;
                        } else {
                            this.users[userIndex].unreadMsg++;
                        }

                        if (isNaN(this.users[userIndex].totalMsg)) {
                            this.users[userIndex].totalMsg = 1;
                        } else {
                            this.users[userIndex].totalMsg++;
                        }      

                        this.applyRecentPreview(this.users[userIndex], data.sender.message);
                        this.users.unshift(this.users.splice(userIndex, 1)[0]);
                        this.$forceUpdate();
                        
                    }

                } else {

                    //USER WHO SENT A MESSAGE IS NOT IN THE LIST OF RECENT USERS, 
                    //WE WILL CREATE A NEW USER ON THE LIST

                    //console.log("private message "+ data.sender.type + " ", data)


                    if (data.sender.type == "CHAT_SUPPORT") {

                        //chat support is sending a message to a user, 
                        //unread message reset to zero
                        let userIndex = this.users.findIndex(user => user.userid == data.recipient.userid)

                        //reset other admin unread message count
                        if (this.users[userIndex]) {
                            this.users[userIndex].unreadMsg = 0;
                            this.applyRecentPreview(this.users[userIndex], data.sender.message);
                            this.users.unshift(this.users.splice(userIndex, 1)[0]);

                            //this.markSeenMessages() //marked as read relegated to when a chat support reply to messages only
                        }                      

                    } else {

                         //the user is online but not on the list since he has no recent messages, 
                        //append the online uses to recent user list and initiazlie unread messages and total messages

                        data.sender.unreadMsg    = 1;
                        data.sender.totalMsg     = 1;
                        data.sender.status      = "online";
                        this.applyRecentPreview(data.sender, data.sender.message);
                        this.users.unshift(data.sender);
             
                    }
                
                }
            }); 

 
            
            //console.log("private MSG", data);
            
            if (data.recipient.userid == this.userid || data.recipient.type == "CHAT_SUPPORT") {                
                //play audio
                let audio = new Audio("/mp3/message-sent.mp3");               
                audio.play();
            }                
        }
    },
    methods: {


        prepareChatBox: function(user) 
        {
            if (typeof this.chatlogs !== 'undefined' &&  this.chatlogs.length > 0) {
                //chatlogs has an array, we will not instantiate the array again. 
            } else {
                this.chatlogs = [];                            
            }

            if (isNaN(this.page)) {
                this.page = 1;                
            }
        },
        sendNewMessage() 
        {        
            this.message = this.outgoingMessage

            let previous_user_id= this.current_user;

            this.current_user = {            
                id:  this.selectedMember.id,
                userid: this.selectedMember.id,
                username: this.selectedMember.username,
                nickname: this.selectedMember.nickname,
                type: "Member",
            }

            if (this.current_user.userid !== previous_user_id) {
                 this.openChatBox(this.current_user); 
                 //no need to send message() since we trigger after 
            } else {
                this.sendMessage();
            }
           
           
        },
        selectUserChatBox(currentUser) {
        
            this.activeUserID  = currentUser.userid;
        },
        openChatBox(currentUser) 
        {
            this.stopAdminTyping();
            this.threadRequestId += 1;
            this.isFetching = false;
            this.page = 1;
            this.chatlogsHistory    = [];
            this.chatlogsUnread     = [];
            this.chatlogs           = [];
            this.current_user       = currentUser;
            this.historyRequested   = false;


            this.selectUserChatBox(currentUser) 

            console.log(this.activeUserID );

            this.isScrollActivated  = false;

            this.historyNotifier    = true;

            this.clearUnreadAttention(currentUser.userid);
            this.editingMessageId = null;
            this.editDraft = "";
            this.messageActionError = "";
            this.loadOpenOutbox();
            
            this.getUnreadMemberMessages(currentUser);

            clearInterval(this.scrollInterval);

            //currentUser.unreadMsg = 0;
            this.$forceUpdate();
        },
        convertNewlineToBr(inputString) {
            return inputString.replace(/\n/g, '<br>');
        },
        sendMessage() {
            this.stopAdminTyping();
            if (this.editingMessageId) {
                this.submitEditedMessage();
                return;
            }

            clearInterval(this.scrollInterval)

            //files is empty and message is empty, stop sending message
            if (this.files.length == 0 && (this.message === "" || this.message === undefined)) 
            {           
                return false;
            }

            document.getElementById("startUpload").click();

            if (this.message === "" || this.message === undefined) {

               //No message just upload

            } else if (!this.sendingText) {
                var plainText = this.message;
                this.sendingText = true;
                this.sendError = "";
                this.deliverSupportText(this.convertNewlineToBr(plainText), this.current_user, null, plainText);
            }         
            

        },
        deliverSupportText(userMessage, chatUser, outboxClientId, plainText) {
            if (!chatUser || !userMessage) {
                this.sendingText = false;
                if (outboxClientId) {
                    this.$delete(this.resendingIds, outboxClientId);
                }
                return;
            }

            var currentTime = new Date();
            var savedTime = currentTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true });
            var savedId = chatUser.id;
            var savedRecipient = {
                'id': chatUser.id,
                'userid': chatUser.userid,
                'username': chatUser.username,
            };
            var savedSender = {
                'msgCtr': 0,
                'userid': this.userid,
                'nickname': this.nickname,
                'username': this.username,
                'message': userMessage,
                'user_image': this.user_image,
                'type': "CHAT_SUPPORT"
            };
            var savedBroadcastRecipient = {
                'id': this.id,
                'userid': this.userid,
                'username': this.username,
            };
            var savedBroadcastSender = {
                'msgCtr': 0,
                'userid': chatUser.userid,
                'nickname': chatUser.nickname,
                'username': chatUser.username,
                'message': userMessage,
                'user_image': chatUser.user_image,
                'type': "CHAT_SUPPORT"
            };
            var self = this;

            axios.post("/api/saveCustomerSupportChat", {
                method              : "POST",
                sender_id           : this.userid,
                recipient_id        : chatUser.userid,
                message             : userMessage,
                is_read             : false,
                valid               : true,
                message_type        : "CHAT_SUPPORT",
            }).then(function (response) {
                self.sendingText = false;
                if (outboxClientId) {
                    self.$delete(self.resendingIds, outboxClientId);
                }
                if (!response.data || response.data.success !== true) {
                    self.holdFailedText(chatUser, userMessage, outboxClientId, plainText);
                    return;
                }

                var historyId = response.data.id || null;
                if (historyId) {
                    savedSender.history_id = historyId;
                    savedBroadcastSender.history_id = historyId;
                }
                if (outboxClientId) {
                    self.removeOutboxItem(chatUser.userid, outboxClientId);
                }
                if (self.current_user && String(self.current_user.userid) === String(chatUser.userid)) {
                    self.appendLocalSupportMessage(historyId, response.data.created_at_iso, savedTime, savedSender);
                }
                var sentIndex = self.users.findIndex(function (user) { return user.userid == chatUser.userid; });
                if (self.users[sentIndex]) {
                    self.applyRecentPreview(self.users[sentIndex], userMessage);
                    self.users.unshift(self.users.splice(sentIndex, 1)[0]);
                }

                if (self.$socket) {
                    self.$socket.emit("SEND_USER_MESSAGE", {
                        id: savedId,
                        time: savedTime,
                        recipient: savedRecipient,
                        sender: savedSender
                    });
                    self.$socket.emit("SEND_OWNER_MESSAGE", {
                        id: savedId,
                        time: savedTime,
                        broadcast_recipient: savedBroadcastRecipient,
                        broadcast_sender: savedBroadcastSender
                    });
                }

                self.markMessagesRead(chatUser);

                var userIndex = self.users.findIndex(function (user) { return user.userid == chatUser.userid; });
                if (self.users[userIndex]) {
                    self.users[userIndex].unreadMsg = 0;
                }

                self.appendRecentUserChatList(self.onlineUsers);
                if (!outboxClientId) {
                    self.outgoingMessage = "";
                    if (plainText === undefined || self.message === plainText) {
                        self.message = "";
                    }
                    self.selectedMember = [];
                    self.$bvModal.hide("createNewMessage");
                }
                self.sendError = "";
                self.scrollToEnd();
                self.prepareButtons();
            }).catch(function () {
                self.sendingText = false;
                if (outboxClientId) {
                    self.$delete(self.resendingIds, outboxClientId);
                }
                self.holdFailedText(chatUser, userMessage, outboxClientId, plainText);
            });
        },
        holdFailedText(chatUser, userMessage, outboxClientId, plainText) {
            if (!outboxClientId) {
                this.rememberUnsent(chatUser.userid, userMessage);
                if (plainText === undefined || this.message === plainText) {
                    this.message = "";
                }
                this.prepareButtons();
            }
            this.sendError = "";
            this.scrollToEnd();
        },  

        onSelect (option) {
            console.log (option)
            
        },

 
        /* search */
        limitText (count) {
            return `and ${count}s`
        },
        clearAll () {
            this.selectedMember = []
        },
        findMember(query) {

            clearTimeout(this.typingTimer)

            this.typingTimer = setTimeout(() => {
                
                if (query.length >= 1) {

                    this.isLoadingMembers = true

                    axios.post("/api/searchMemberName", {
                        method         : "POST",
                        query          : query
                    }).then(response => {  
                        this.members = response.data.members;
                        this.isLoadingMembers = false;
                    });
                                
                }
            }, 1000)
        },

        hideChatBox() {
            this.current_user = null;
            this.outbox = [];
            this.editingMessageId = null;
            this.editDraft = "";
        },
        showPreviousMessages() {
            this.historyRequested = true;
            this.getChatHistory(this.current_user, false);
        },
        recentPreview(message) {
            var raw = String(message || "");
            var kind = "text";
            if (/<img\b/i.test(raw) || /\.(?:jpe?g|png|gif|webp)(?:\?[^"'<\s]*)?(?:["'\s<]|$)/i.test(raw)) {
                kind = "image";
            } else if (/\.pdf(?:\?[^"'<\s]*)?(?:["'\s<]|$)/i.test(raw)) {
                kind = "pdf";
            } else if (/\.docx?(?:\?[^"'<\s]*)?(?:["'\s<]|$)/i.test(raw)) {
                kind = "document";
            } else if (/<a\b[^>]*\bhref\s*=/i.test(raw) || /href\s*=\s*["'][^"']+\.(?:zip|rar|7z|xlsx?|pptx?|csv|txt)(?:\?[^"']*)?["']/i.test(raw)) {
                kind = "file";
            }
            var text = raw
                .replace(/<br\s*\/?>/gi, " ")
                .replace(/<[^>]+>/g, " ")
                .replace(/&nbsp;/gi, " ")
                .replace(/&amp;/gi, "&")
                .replace(/\s+/g, " ")
                .trim();
            if (kind === "image") {
                text = "Sent an image";
            } else if (kind === "pdf") {
                text = "Sent a PDF";
            } else if (kind === "document") {
                text = "Sent a document";
            } else if (kind === "file") {
                text = "Sent a file";
            } else if (text.length > 30) {
                text = text.substring(0, 27) + "...";
            }
            return { kind: kind, text: text };
        },
        applyRecentPreview(user, message) {
            if (!user) {
                return;
            }
            var preview = this.recentPreview(message);
            this.$set(user, "recentMsg", preview.text);
            this.$set(user, "recentKind", preview.kind);
            this.$set(user, "recentAt", new Date().toISOString());
        },
        recentIcon(kind) {
            if (kind === "image") {
                return "far fa-image";
            }
            if (kind === "pdf") {
                return "far fa-file-pdf";
            }
            if (kind === "document") {
                return "far fa-file-alt";
            }
            if (kind === "file") {
                return "far fa-file";
            }
            return "";
        },
        formatRecentAt(value) {
            if (!value) {
                return "";
            }
            var date = new Date(value);
            if (isNaN(date.getTime())) {
                return "";
            }
            var now = new Date();
            var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var time = (hours < 10 ? "0" : "") + hours + ":" + (minutes < 10 ? "0" : "") + minutes;
            if (date.getFullYear() === now.getFullYear()) {
                return time;
            }
            var label = months[date.getMonth()] + " " + date.getDate();
            return label + ", " + date.getFullYear() + " " + time;
        },
        threadStillOpen(requestId, memberId) {
            return requestId === this.threadRequestId
                && this.current_user
                && String(this.current_user.userid) === String(memberId);
        },
        getChatHistory(user, scrollToBottom) {
            if (!user || this.isFetching) {
                return;
            }
            if (this.page > 1 && this.historyNotifier == false) {
                return;
            }

            var requestId = this.threadRequestId;
            var memberId = user.userid;
            this.isFetching = true;

            if (this.page == 1) {
                this.chatlogsHistory = [];
            }

            var requestedPage = this.page;
            var beforeId = 0;
            if (requestedPage > 1 && this.chatlogsHistory.length && this.chatlogsHistory[0].id) {
                beforeId = this.chatlogsHistory[0].id;
            }

            axios.post("/api/getAdminChatHistory",
            {
                method              : "POST",
                sender_id           : user.userid,
                recipient_id        : this.userid,
                page                : requestedPage,
                before_id           : beforeId

            }).then(response => {
                if (!this.threadStillOpen(requestId, memberId)) {
                    return;
                }

                if (response.data.success === true)
                {
                    var pageInfo = response.data.chatHistoryItems;
                    this.page = pageInfo.current_page + 1;

                    if (pageInfo.last_page == pageInfo.current_page) {
                        this.historyNotifier = false;
                    }

                    var seen = {};
                    this.chatlogsHistory.forEach(function (item) {
                        if (item.id) {
                            seen[item.id] = true;
                        }
                    });

                    var added = 0;
                    pageInfo.data.forEach(data => {
                        if (seen[data.id]) {
                            return;
                        }
                        if (data.message_type == "MEMBER" && String(data.sender_id) !== String(memberId)) {
                            return;
                        }
                        if (data.message_type == "CHAT_SUPPORT" && String(data.recipient_id) !== String(memberId)) {
                            return;
                        }
                        if (data.message_type != "MEMBER" && data.message_type != "CHAT_SUPPORT") {
                            return;
                        }
                        seen[data.id] = true;
                        added++;

                        var chatboxUsername = null;
                        var chatboxNickname = null;
                        var chatboxImage = null;

                        if (data.message_type == "MEMBER") {
                            chatboxUsername = user.username;
                            chatboxNickname = user.nickname;
                            chatboxImage = user.user_image;
                        } else {
                            chatboxUsername = this.username;
                            chatboxNickname = this.nickname;
                            chatboxImage = this.user_image;
                        }

                        this.chatlogsHistory.unshift({
                            id: data.id,
                            time: data.created_at,
                            sentAt: data.created_at_iso || data.created_at,
                            sender: {
                                'msgCtr': 0,
                                'userid': data.userid,
                                'nickname': chatboxNickname,
                                'username': chatboxUsername,
                                'user_image': chatboxImage,
                                'message': data.message,
                                'type': data.message_type
                            },
                        });
                    });

                    if (added === 0) {
                        this.historyNotifier = false;
                    }

                    var container = this.$el.querySelector("#user-chatlog");
                    var previousHeight = container ? container.scrollHeight : 0;
                    var previousTop = container ? container.scrollTop : 0;

                    var self = this;
                    this.$nextTick(() => {
                        if (!self.threadStillOpen(requestId, memberId)) {
                            return;
                        }
                        self.$forceUpdate();
                        self.$nextTick(() => {
                            if (!self.threadStillOpen(requestId, memberId)) {
                                return;
                            }
                            if (scrollToBottom == true) {
                                self.scrollToEnd();
                            } else if (added > 0) {
                                self.keepHistoryScroll(previousHeight, previousTop);
                            }
                            self.isFetching = false;
                            self.fillHistoryIfNoScrollbar();
                        });
                    });

                } else {
                    this.historyNotifier = false;
                    this.isFetching = false;

                    this.$nextTick(() => {
                        this.$forceUpdate();
                        if (scrollToBottom == true) {
                            this.scrollToEnd();
                        }
                    });
                }

                if (this.outgoingMessage.length >= 1) {
                    this.sendMessage();
                }

            }).catch((error) => {
                if (!this.threadStillOpen(requestId, memberId)) {
                    return;
                }
                this.isFetching = false;
                console.log("Error " + error);
            });

        },        
        getUnreadMemberMessages(user) 
        {

            this.isLoading = true;
            var self = this;
            var requestId = this.threadRequestId;
            var memberId = user.userid;

            axios.post("/api/getAdminUnreadChatMessages", 
            {
                method           : "POST",
                sender_id         : user.userid,
            }).then(response => {  

                if (!self.threadStillOpen(requestId, memberId)) {
                    return;
                }

                var unread = [];
                if (response.data.success === true) 
                {
                    response.data.chatItems.forEach(data => {
                        if (String(data.sender_id) !== String(memberId) || data.message_type !== "MEMBER") {
                            return;
                        }

                        let chatboxUsername = null;
                        let chatboxNickname = null;
                        let chatboxImage = null;

                        if (data.message_type == "MEMBER") {
                            chatboxUsername = user.username;
                            chatboxNickname = user.nickname   
                            chatboxImage = user.user_image;                         
                        } else {
                            chatboxUsername = self.username;
                            chatboxNickname = self.nickname
                            chatboxImage = self.user_image;
                        }

                        let sender = {
                            'msgCtr': 0,
                            'userid': data.userid,
                            'nickname': chatboxNickname,
                            'username': chatboxUsername,          
                            'user_image': chatboxImage,
                            'message': data.message, 
                            'is_read': data.is_read,                           
                            'type': data.message_type
                        };

                        unread.unshift({
                                id: data.id,
                                time: data.created_at,
                                sentAt: data.created_at_iso || data.created_at,
                                sender: sender,
                        });  
                    });
                }

                if (!self.threadStillOpen(requestId, memberId)) {
                    return;
                }
                self.chatlogsUnread = unread;

                self.$nextTick(function()
                {
                    if (!self.threadStillOpen(requestId, memberId)) {
                        return;
                    }
                    self.$forceUpdate();
                    self.isLoading = false;
                    self.$nextTick(function () {
                        if (self.threadStillOpen(requestId, memberId)) {
                            self.isScrollActivated = true;
                        }
                    });
                });
                
            }).catch(function () {
                if (!self.threadStillOpen(requestId, memberId)) {
                    return;
                }
                self.isLoading = false;
            });
        },      
        fillHistoryIfNoScrollbar: function () {
            var el = this.$el.querySelector("#user-chatlog");
            if (!el || !this.historyRequested || this.isFetching || this.historyNotifier == false || !this.current_user) {
                return;
            }
            if (el.clientHeight > 0 && el.scrollHeight > el.clientHeight + 2) {
                return;
            }
            this.getChatHistory(this.current_user, false);
        },
        keepHistoryScroll(previousHeight, previousTop) {
            var container = this.$el.querySelector("#user-chatlog");
            if (!container) {
                return;
            }
            var addedHeight = container.scrollHeight - previousHeight;
            if (addedHeight < 0) {
                addedHeight = 0;
            }
            this.historyAdjusting = true;
            container.scrollTop = previousTop + addedHeight;
            this.historyAdjusting = false;
        },
        scrollToTop() {
            this.$forceUpdate();
            var container = this.$el.querySelector("#user-chatlog");
            if(container){            
                container.scrollTop = 500;
            }
        },          
        scrollToEnd() {
            setTimeout(() => {  this.executeScroll() }, 100);
        },
        executeScroll() {  
            let  container = this.$el.querySelector("#user-chatlog");
            if(container) {
                container.scrollTop = container.scrollHeight;  
                this.isScrollActivated = true;
            }
        },
        handleScroll(event) {
            if (!this.historyRequested || this.historyAdjusting || this.isScrollActivated != true || this.isFetching || this.historyNotifier == false) {
                return;
            }
            if (event.target.scrollTop <= 40) {
                this.getChatHistory(this.current_user, false);
            }
        },
        markMessagesRead(user) 
        {
            axios.post("/api/markAdminChatMessagesRead", 
            {
                method           : "POST",
                userID           : user.userid,
                message_type     : 'MEMBER'
            }).then(response => {  

                if (response.data.success === true) 
                { 
                   console.log(response.data.message);
                } 
            });    
        },  
          
        prepareButtons: function() {
            let fileSelectBtn = document.getElementById("file-select-button");
            let sendBtn = document.getElementById("send-button");

            if (fileSelectBtn) {
                fileSelectBtn.style.display = "block";
            }
            if (sendBtn) {
                sendBtn.style.display = "block";
            }
        },
        onChatImageClick: function (event) {
            if (event.target.closest('.member-image')) {
                return;
            }
            var bubble = event.target.closest('.admin-chat-bubble');
            if (!bubble) {
                return;
            }
            var img = event.target.closest('img');
            if (!img || !bubble.contains(img)) {
                var anchor = event.target.closest('a');
                img = anchor && bubble.contains(anchor) ? anchor.querySelector('img') : null;
            }
            if (!this.isChatPreviewImage(img) || !bubble.contains(img)) {
                return;
            }
            event.preventDefault();
            var log = document.getElementById('user-chatlog');
            var nodes = log ? log.querySelectorAll('.admin-chat-bubble img') : [];
            var images = [];
            var index = 0;
            var self = this;
            Array.prototype.forEach.call(nodes, function (node) {
                if (!self.isChatPreviewImage(node)) {
                    return;
                }
                if (node === img) {
                    index = images.length;
                }
                images.push(self.chatImageItem(node));
            });
            if (!images.length) {
                return;
            }
            this.imagePreview = { images: images, index: index };
            this.$nextTick(function () {
                if (self.$refs.imagePreview) {
                    self.$refs.imagePreview.focus();
                }
            });
        },
        isChatPreviewImage: function (img) {
            if (!img || img.classList.contains('member-image')) {
                return false;
            }
            var link = img.closest('a');
            var src = img.currentSrc || img.src;
            if (link && link.href !== src && !/\.(jpe?g|png|gif|webp|bmp)([?#]|$)/i.test(link.href)) {
                return false;
            }
            return true;
        },
        chatImageItem: function (img) {
            var src = img.currentSrc || img.src;
            var name = img.alt || String(src).split(/[?#]/)[0].split('/').pop();
            try { name = decodeURIComponent(name); } catch (e) { /* keep the raw name */ }
            return { src: src, name: name };
        },
        previewImage: function () {
            if (!this.imagePreview || !this.imagePreview.images) {
                return { src: '', name: '' };
            }
            return this.imagePreview.images[this.imagePreview.index] || { src: '', name: '' };
        },
        showPreviewImage: function (index) {
            if (!this.imagePreview || this.imagePreview.images.length < 2) {
                return;
            }
            var count = this.imagePreview.images.length;
            this.imagePreview.index = ((index % count) + count) % count;
        },
        closeImagePreview: function () {
            this.imagePreview = null;
        },
        onUserListScroll: function (event) {
            this.loadMoreUsers(event.target);
        },
        onUserListWheel: function (event) {
            if (event.deltaY > 0) {
                this.loadMoreUsers(event.currentTarget);
            }
        },
        loadMoreUsers: function (el) {
            if (!el || this.userListLoading || !this.userListHasMore) {
                return;
            }
            var remaining = el.scrollHeight - el.scrollTop - el.clientHeight;
            if (remaining > el.scrollHeight * 0.1) {
                return;
            }
            if (this.userListLimit < this.chatUsers.length) {
                this.revealNextLocalUsers();
                return;
            }
            this.appendRecentUserChatList(this.onlineUsers, true);
        },
        clearUserListFillTimer: function () {
            if (this.userListFillTimer) {
                clearTimeout(this.userListFillTimer);
                this.userListFillTimer = null;
            }
        },
        userListNeedsScrollbarFill: function () {
            var el = this.$refs.userListBody;
            if (!el || this._isDestroyed || this._isBeingDestroyed) {
                return false;
            }
            if (el.clientHeight > 0 && el.scrollHeight > el.clientHeight + 2) {
                return false;
            }
            if (this.userListLimit < this.chatUsers.length) {
                return true;
            }
            return this.userListHasMore;
        },
        scheduleUserListFill: function () {
            this.clearUserListFillTimer();
            var self = this;
            var requestId = this.userListRequestId;
            this.$nextTick(function () {
                if (requestId !== self.userListRequestId || !self.userListNeedsScrollbarFill()) {
                    return;
                }
                self.userListFillTimer = setTimeout(function () {
                    self.userListFillTimer = null;
                    if (requestId !== self.userListRequestId || self._isDestroyed || self._isBeingDestroyed) {
                        return;
                    }
                    self.fillUserListToScrollbar();
                }, 500);
            });
        },
        revealNextLocalUsers: function () {
            this.clearUserListFillTimer();
            this.userListLoading = true;
            this.userListLimit += this.userListPageSize;
            var self = this;
            this.$nextTick(function () {
                self.userListLoading = false;
                self.scheduleUserListFill();
            });
        },
        fillUserListToScrollbar: function () {
            if (this.userListLoading) {
                this.scheduleUserListFill();
                return;
            }
            if (!this.userListNeedsScrollbarFill()) {
                return;
            }
            if (this.userListLimit < this.chatUsers.length) {
                this.revealNextLocalUsers();
                return;
            }
            this.appendRecentUserChatList(this.onlineUsers, true);
        },
        mapRecentChatUsers(recentUsers, onlineUsers) {
            var users = [];
            var source = recentUsers || [];
            Object.keys(source).forEach(function (index) {
                var recentUser = source[index];
                var isOnline = (onlineUsers || []).find(function (onlineUser) {
                    return onlineUser.userid == recentUser.userid;
                });
                if (isOnline) {
                    recentUser.status = 'online';
                } else {
                    recentUser.status = 'offline';
                }
                users.push(recentUser);
            });
            return users;
        },
        appendRecentUserChatList(onlineUsers, append) {
            var reset = !append;
            this.clearUserListFillTimer();
            var offset = reset ? 0 : this.userListOffset;
            var requestId = ++this.userListRequestId;
            var self = this;
            this.userListLoading = true;

            axios.post("/api/getRecentUserChatList",
            {
                method: "POST",
                limit: this.userListPageSize,
                offset: offset,
            }).then(response => {
                if (requestId !== self.userListRequestId) {
                    return;
                }

                if (response.data && response.data.total !== undefined && response.data.total !== null) {
                    var parsedTotal = Number(response.data.total);
                    if (isFinite(parsedTotal) && parsedTotal >= 0) {
                        self.userListTotal = Math.floor(parsedTotal);
                    }
                }

                if (response.data.success === true)
                {
                    self.recentUsers = response.data.recentUsers;
                    var batch = self.mapRecentChatUsers(self.recentUsers, onlineUsers);

                    if (reset) {
                        self.users = batch;
                        self.userListOffset = batch.length;
                        self.userListLimit = self.userListPageSize;
                        self.userListHasMore = batch.length >= self.userListPageSize;
                    } else {
                        var seen = {};
                        self.users.forEach(function (user) {
                            seen[user.userid] = true;
                        });
                        var added = batch.filter(function (user) {
                            return !seen[user.userid];
                        });
                        self.users = self.users.concat(added);
                        self.userListOffset = offset + batch.length;
                        self.userListLimit += added.length;
                        if (batch.length < self.userListPageSize) {
                            self.userListHasMore = false;
                        }
                    }
                } else if (reset) {
                    //show only online users (no recent users)
                    self.users = onlineUsers;
                    self.userListLimit = self.userListPageSize;
                    self.userListOffset = 0;
                    self.userListHasMore = false;

                    if (self.current_user !== null) {
                        self.openChatBox(self.current_user);
                    }
                } else {
                    self.userListHasMore = false;
                }

            }).catch(function(error) {
                console.log("Error " + error);
            }).then(function () {
                if (requestId !== self.userListRequestId) {
                    return;
                }
                self.userListLoading = false;
                self.scheduleUserListFill();
            });
        },
        updateUserList: function(users) 
        {
            if (!Array.isArray(users)) {
                return;
            }
            //filter chat support, we will not show on the list if the users is a chat support
            let fusers = users.filter(user => user.type !== "CHAT_SUPPORT");
            
            //filter duplicates
            this.onlineUsers = this.filterUnique(fusers);   
            this.applyOnlineStatus();
        },
        applyOnlineStatus: function () {
            var onlineIds = {};
            (this.onlineUsers || []).forEach(function (user) {
                if (user && user.userid !== undefined && user.userid !== null) {
                    onlineIds[String(user.userid)] = true;
                }
            });
            var self = this;
            this.users.forEach(function (user) {
                var next = onlineIds[String(user.userid)] ? 'online' : 'offline';
                if (user.status !== next) {
                    self.$set(user, 'status', next);
                }
            });
            if (this.current_user && this.current_user.userid !== undefined && this.current_user.userid !== null) {
                var currentStatus = onlineIds[String(this.current_user.userid)] ? 'online' : 'offline';
                if (this.current_user.status !== currentStatus) {
                    this.$set(this.current_user, 'status', currentStatus);
                }
            }
        },      
        filterUnique: function (users) {
          let result = users.reduce((unique, o) => {
              if(!unique.some(obj => obj.username === o.username )) {
                unique.push(o);
              }
              return unique;
          },[]);          
          return result;
        },
        markSeenMessages() {          
            this.markMessagesRead(this.current_user);            
        },
        enterAdminChat: function() {
            this.adminUser = {
                userid: this.userid,
                username: this.username,
                nickname: "Customer Support",
                status: "online",
                type: "CHAT_SUPPORT",
            }
            this.$socket.emit('REGISTER', this.adminUser);
        },       


        windowTitleToggle() {
            if (this.tabTitle == "") {
                this.tabTitle = "You have a message";
            } else {
                this.tabTitle = "";
            }
             document.title = this.tabTitle;
        },
        noteUnreadAttention(userId) {
            if (userId === undefined || userId === null) {
                return;
            }
            this.$set(this.attentionUsers, String(userId), true);
        },
        clearUnreadAttention(userId) {
            if (userId !== undefined && userId !== null) {
                this.$delete(this.attentionUsers, String(userId));
            }
            if (Object.keys(this.attentionUsers).length === 0) {
                this.stopBlink();
            }
        },
        blink() {
            if (this.interval) {
                return;
            }
            var self = this;
            this.interval = setInterval(function () {
                self.windowTitleToggle();
            }, 1000);
        },
        stopBlink() {
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
            }
            this.tabTitle = "";
            if (this.TabTitle) {
                document.title = this.TabTitle;
            }
        },
        outboxStorageKey() {
            return "adminChatOutbox:" + String(this.userid);
        },
        readOutboxStore() {
            try {
                var raw = localStorage.getItem(this.outboxStorageKey());
                var parsed = raw ? JSON.parse(raw) : {};
                if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
                    return {};
                }
                return parsed;
            } catch (e) {
                return {};
            }
        },
        writeOutboxStore(store) {
            try {
                var keys = Object.keys(store || {});
                if (!keys.length) {
                    localStorage.removeItem(this.outboxStorageKey());
                    return;
                }
                localStorage.setItem(this.outboxStorageKey(), JSON.stringify(store));
            } catch (e) {
                // Storage can be unavailable; the in-memory outbox still shows for this view.
            }
        },
        readMemberOutbox(memberId) {
            var store = this.readOutboxStore();
            var list = store[String(memberId)];
            return Array.isArray(list) ? list : [];
        },
        writeMemberOutbox(memberId, list) {
            var store = this.readOutboxStore();
            var key = String(memberId);
            if (!list || !list.length) {
                delete store[key];
            } else {
                store[key] = list;
            }
            this.writeOutboxStore(store);
        },
        loadOpenOutbox() {
            if (!this.current_user) {
                this.outbox = [];
                return;
            }
            this.outbox = this.readMemberOutbox(this.current_user.userid).slice();
        },
        rememberUnsent(memberId, message) {
            if (!memberId || !message) {
                return;
            }
            var list = this.readMemberOutbox(memberId);
            list.push({
                clientId: "out-" + Date.now() + "-" + Math.floor(Math.random() * 100000),
                message: message,
                createdAt: new Date().toISOString(),
            });
            this.writeMemberOutbox(memberId, list);
            if (this.current_user && String(this.current_user.userid) === String(memberId)) {
                this.outbox = list.slice();
            }
        },
        removeOutboxItem(memberId, clientId) {
            var list = this.readMemberOutbox(memberId).filter(function (item) {
                return item.clientId !== clientId;
            });
            this.writeMemberOutbox(memberId, list);
            if (this.current_user && String(this.current_user.userid) === String(memberId)) {
                this.outbox = list.slice();
            }
        },
        resendOutbox(item) {
            if (!item || !this.current_user || this.resendingIds[item.clientId]) {
                return;
            }
            this.$set(this.resendingIds, item.clientId, true);
            this.deliverSupportText(item.message, this.current_user, item.clientId, null);
        },
        discardOutbox(item) {
            if (!item || !this.current_user || this.resendingIds[item.clientId]) {
                return;
            }
            this.removeOutboxItem(this.current_user.userid, item.clientId);
        },
        formatOutboxMessage(message) {
            return String(message || "")
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/&lt;br\s*\/?&gt;/gi, "<br>");
        },
        threadHasMessageId(id) {
            if (id === undefined || id === null || id === "") {
                return false;
            }
            var key = String(id);
            var lists = [this.chatlogsHistory, this.chatlogsUnread, this.chatlogs];
            for (var i = 0; i < lists.length; i++) {
                var list = lists[i] || [];
                for (var j = 0; j < list.length; j++) {
                    if (list[j] && String(list[j].id) === key) {
                        return true;
                    }
                }
            }
            return false;
        },
        appendLocalSupportMessage(historyId, iso, timeLabel, sender) {
            if (historyId && this.threadHasMessageId(historyId)) {
                return;
            }
            this.chatlogs.push({
                id: historyId,
                time: timeLabel,
                sentAt: iso || new Date().toISOString(),
                sender: sender,
            });
            this.$forceUpdate();
        },
        pushIncomingSupportLog(historyId, timeLabel, sender) {
            if (historyId && this.threadHasMessageId(historyId)) {
                return;
            }
            var last = this.chatlogs.length ? this.chatlogs[this.chatlogs.length - 1] : null;
            if (!historyId && last && last.id && last.sender && last.sender.message === sender.message && last.sender.type === "CHAT_SUPPORT") {
                return;
            }
            this.chatlogs.push({
                id: historyId,
                time: timeLabel,
                sentAt: new Date().toISOString(),
                sender: sender,
            });
            this.$forceUpdate();
        },
        updateThreadMessage(id, message) {
            var key = String(id);
            [this.chatlogsHistory, this.chatlogsUnread, this.chatlogs].forEach(function (list) {
                (list || []).forEach(function (item) {
                    if (item && String(item.id) === key && item.sender) {
                        item.sender.message = message;
                    }
                });
            });
        },
        replaceEditedThreadMessage(oldId, newId, message, sentAt) {
            var key = String(oldId);
            var self = this;
            [this.chatlogsHistory, this.chatlogsUnread, this.chatlogs].forEach(function (list) {
                (list || []).forEach(function (item, index) {
                    if (!item || String(item.id) !== key || !item.sender) {
                        return;
                    }
                    self.$set(list, index, Object.assign({}, item, {
                        id: newId,
                        sentAt: sentAt || item.sentAt,
                        sender: Object.assign({}, item.sender, { message: message }),
                    }));
                });
            });
        },
        removeThreadMessage(id) {
            var key = String(id);
            var keep = function (item) {
                return !(item && String(item.id) === key);
            };
            this.chatlogsHistory = this.chatlogsHistory.filter(keep);
            this.chatlogsUnread = this.chatlogsUnread.filter(keep);
            this.chatlogs = this.chatlogs.filter(keep);
        },
        supportSentAtMs(value) {
            if (value === null || value === undefined || value === "") {
                return null;
            }
            if (typeof value === "number") {
                if (!isFinite(value)) {
                    return null;
                }
                return value < 100000000000 ? value * 1000 : value;
            }
            var text = String(value).trim();
            if (!/^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}/.test(text)) {
                return null;
            }
            var ms = Date.parse(text);
            if (isNaN(ms)) {
                return null;
            }
            return ms;
        },
        supportMessageIsRecent(sentMs, nowMs) {
            if (sentMs === null || !isFinite(sentMs)) {
                return false;
            }
            var now = Number(nowMs);
            if (!isFinite(now)) {
                now = Date.now();
            }
            var age = now - sentMs;
            if (age < -120000) {
                return false;
            }
            if (age < 0) {
                age = 0;
            }
            return age < 5 * 60 * 1000;
        },
        latestRecentSupportId(nowMs) {
            var best = null;
            var bestAt = -1;
            var bestId = -1;
            var self = this;
            [this.chatlogsHistory, this.chatlogsUnread, this.chatlogs].forEach(function (list) {
                (list || []).forEach(function (item) {
                    if (!item || !item.id || !item.sender || item.sender.type !== "CHAT_SUPPORT") {
                        return;
                    }
                    var at = self.supportSentAtMs(item.sentAt);
                    if (at === null || !self.supportMessageIsRecent(at, nowMs)) {
                        return;
                    }
                    var id = Number(item.id);
                    if (!isFinite(id)) {
                        id = 0;
                    }
                    if (at > bestAt || (at === bestAt && id >= bestId)) {
                        best = item;
                        bestAt = at;
                        bestId = id;
                    }
                });
            });
            return best ? best.id : null;
        },
        latestSupportId() {
            var best = null;
            var bestAt = -1;
            var bestId = -1;
            var self = this;
            [this.chatlogsHistory, this.chatlogsUnread, this.chatlogs].forEach(function (list) {
                (list || []).forEach(function (item) {
                    if (!item || !item.id || !item.sender || item.sender.type !== "CHAT_SUPPORT") {
                        return;
                    }
                    var at = self.supportSentAtMs(item.sentAt);
                    if (at === null) {
                        at = 0;
                    }
                    var id = Number(item.id);
                    if (!isFinite(id)) {
                        id = 0;
                    }
                    if (at > bestAt || (at === bestAt && id >= bestId)) {
                        best = item;
                        bestAt = at;
                        bestId = id;
                    }
                });
            });
            return best ? best.id : null;
        },
        plainFromStored(html) {
            return String(html || "")
                .replace(/<br\s*\/?>/gi, "\n")
                .replace(/<\/p>/gi, "\n")
                .replace(/<[^>]+>/g, "")
                .replace(/&nbsp;/gi, " ")
                .replace(/&amp;/g, "&")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, "\"");
        },
        startEditMessage(chatlog) {
            if (!chatlog || !chatlog.sender || String(this.latestEditableId) !== String(chatlog.id)) {
                return;
            }
            this.messageActionError = "";
            this.editingMessageId = chatlog.id;
            this.message = this.plainFromStored(chatlog.sender.message);
            var self = this;
            this.$nextTick(function () {
                self.prepareButtons();
                var el = document.getElementById("message");
                if (el) {
                    el.focus();
                }
            });
        },
        cancelEditMessage() {
            this.editingMessageId = null;
            this.editDraft = "";
            this.message = "";
            this.stopAdminTyping();
            var self = this;
            this.$nextTick(function () {
                self.prepareButtons();
            });
        },
        submitEditedMessage() {
            var editId = this.editingMessageId;
            var text = (this.message || "").trim();
            if (!editId) {
                return;
            }
            if (!text) {
                return;
            }
            if (String(this.latestRecentSupportId(Date.now())) !== String(editId)) {
                this.editingMessageId = null;
                this.message = "";
                this.messageActionError = "This message can only be changed within 5 minutes of sending.";
                var expired = this;
                this.$nextTick(function () {
                    expired.prepareButtons();
                });
                return;
            }
            var payload = this.convertNewlineToBr(text);
            var self = this;
            this.messageActionError = "";
            axios.post("/api/updateAdminChatMessage", {
                method: "POST",
                id: editId,
                message: payload,
            }).then(function (response) {
                if (!response.data || response.data.success !== true) {
                    self.messageActionError = (response.data && response.data.message) ? response.data.message : "The message could not be edited.";
                    return;
                }
                var editedText = response.data.message || payload;
                var newId = response.data.id || editId;
                self.replaceEditedThreadMessage(editId, newId, editedText, response.data.created_at_iso);
                self.notifyMemberOfEdit(newId, editedText);
                if (self.current_user) {
                    var sentIndex = self.users.findIndex(function (user) { return String(user.userid) === String(self.current_user.userid); });
                    if (sentIndex >= 0) {
                        var preview = self.recentPreview(editedText);
                        self.$set(self.users[sentIndex], "recentMsg", preview.text);
                        self.$set(self.users[sentIndex], "recentKind", preview.kind);
                    }
                }
                self.editingMessageId = null;
                self.message = "";
                self.$nextTick(function () {
                    self.prepareButtons();
                });
            }).catch(function (error) {
                var data = error.response && error.response.data;
                self.messageActionError = (data && data.message) ? data.message : "The message could not be edited.";
                if (data && /5 minutes|latest support/i.test(data.message || "")) {
                    self.editingMessageId = null;
                    self.message = "";
                    self.$nextTick(function () {
                        self.prepareButtons();
                    });
                }
            });
        },
        readSupportEdit(data) {
            if (!data || !data.sender) {
                return null;
            }
            var message = data.sender.message == null ? "" : String(data.sender.message);
            var deleted = message.match(/^\[\[cs-delete:(\d+)\]\]/);
            var edited = message.match(/^\[\[cs-edit:(\d+)\]\]/);
            var kind = null;
            var historyId = null;
            var clean = message;
            if (deleted || data.action === "delete" || data.sender.action === "delete") {
                kind = "delete";
                historyId = deleted ? deleted[1] : null;
                clean = deleted ? message.slice(deleted[0].length) : message;
            } else if (edited || data.action === "edit" || data.sender.action === "edit") {
                kind = "edit";
                historyId = edited ? edited[1] : null;
                clean = edited ? message.slice(edited[0].length) : message;
            }
            if (!kind) {
                return null;
            }
            if (historyId === null || historyId === "") {
                historyId = data.sender.history_id || data.id;
            }
            return { kind: kind, historyId: historyId, message: clean };
        },
        notifyMemberOfEdit(historyId, message) {
            if (!this.$socket || !this.current_user || !historyId) {
                return;
            }
            var currentTime = new Date();
            var wireMessage = "[[cs-edit:" + historyId + "]]" + message;
            this.$socket.emit("SEND_USER_MESSAGE", {
                action: "edit",
                id: historyId,
                time: currentTime.toLocaleString("en-US", { hour: "numeric", minute: "numeric", second: "numeric", hour12: true }),
                recipient: {
                    id: this.current_user.id,
                    userid: this.current_user.userid,
                    username: this.current_user.username,
                },
                sender: {
                    userid: this.userid,
                    username: this.username,
                    nickname: this.nickname,
                    message: wireMessage,
                    user_image: this.user_image,
                    type: "CHAT_SUPPORT",
                    history_id: historyId,
                    action: "edit",
                }
            });
        },
        isMemberTyping(user) {
            if (!user || user.userid === undefined || user.userid === null) {
                return false;
            }
            return !!this.typingMembers[String(user.userid)];
        },
        presenceLabel(user) {
            if (this.isMemberTyping(user)) {
                return "Typing…";
            }
            return user && user.status == "online" ? "Online" : "Offline";
        },
        presenceClass(user) {
            if (this.isMemberTyping(user)) {
                return "is-typing";
            }
            return user && user.status == "online" ? "is-online" : "is-offline";
        },
        onRemoteTyping(data) {
            if (!data || data.from_type !== "MEMBER") {
                return;
            }
            if (String(data.from_userid) === String(this.userid)) {
                return;
            }
            var memberId = String(data.member_id || data.from_userid);
            if (data.active) {
                this.$set(this.typingMembers, memberId, true);
                this.armTypingExpiry(memberId);
            } else {
                this.clearMemberTyping(memberId);
            }
        },
        armTypingExpiry(memberId) {
            var self = this;
            if (this.typingExpiry[memberId]) {
                clearTimeout(this.typingExpiry[memberId]);
            }
            this.typingExpiry[memberId] = setTimeout(function () {
                self.clearMemberTyping(memberId);
            }, 4000);
        },
        clearMemberTyping(memberId) {
            if (this.typingExpiry[memberId]) {
                clearTimeout(this.typingExpiry[memberId]);
                delete this.typingExpiry[memberId];
            }
            this.$delete(this.typingMembers, String(memberId));
        },
        onComposerActivity() {
            this.prepareButtons();
            this.notifyAdminTyping();
        },
        notifyAdminTyping() {
            if (!this.current_user) {
                return;
            }
            if (!String(this.message || "").trim()) {
                this.stopAdminTyping();
                return;
            }
            var now = Date.now();
            if (!this.adminTypingActive || now - this.adminTypingSentAt > 1500) {
                this.adminTypingActive = true;
                this.adminTypingSentAt = now;
                this.emitAdminTyping(true);
            }
            clearTimeout(this.adminTypingTimer);
            var self = this;
            this.adminTypingTimer = setTimeout(function () {
                self.stopAdminTyping();
            }, 2000);
        },
        stopAdminTyping() {
            clearTimeout(this.adminTypingTimer);
            this.adminTypingTimer = null;
            if (!this.adminTypingActive) {
                return;
            }
            this.adminTypingActive = false;
            this.emitAdminTyping(false);
        },
        emitAdminTyping(active) {
            if (!this.$socket || !this.current_user) {
                return;
            }
            this.$socket.emit("CHAT_TYPING", {
                active: !!active,
                member_id: this.current_user.userid,
                from_type: "CHAT_SUPPORT",
                from_userid: this.userid,
            });
        },
        notifyMemberOfDelete(historyId) {
            if (!this.$socket || !this.current_user || !historyId) {
                return;
            }
            var currentTime = new Date();
            this.$socket.emit("SEND_USER_MESSAGE", {
                action: "delete",
                id: historyId,
                time: currentTime.toLocaleString("en-US", { hour: "numeric", minute: "numeric", second: "numeric", hour12: true }),
                recipient: {
                    id: this.current_user.id,
                    userid: this.current_user.userid,
                    username: this.current_user.username,
                },
                sender: {
                    userid: this.userid,
                    username: this.username,
                    nickname: this.nickname,
                    message: "[[cs-delete:" + historyId + "]]",
                    user_image: this.user_image,
                    type: "CHAT_SUPPORT",
                    history_id: historyId,
                    action: "delete",
                }
            });
        },
        deleteThreadMessage(chatlog) {
            if (!chatlog || !chatlog.id) {
                return;
            }
            if (String(this.latestRecentSupportId(Date.now())) !== String(chatlog.id)) {
                this.messageActionError = "This message can only be deleted within 5 minutes of sending.";
                return;
            }
            if (!window.confirm("Delete this message?")) {
                return;
            }
            if (String(this.latestRecentSupportId(Date.now())) !== String(chatlog.id)) {
                this.messageActionError = "This message can only be deleted within 5 minutes of sending.";
                return;
            }
            var self = this;
            this.messageActionError = "";
            axios.post("/api/deleteAdminChatMessage", {
                method: "POST",
                id: chatlog.id,
            }).then(function (response) {
                if (!response.data || response.data.success !== true) {
                    self.messageActionError = (response.data && response.data.message) ? response.data.message : "The message could not be deleted.";
                    return;
                }
                if (String(self.editingMessageId) === String(chatlog.id)) {
                    self.cancelEditMessage();
                }
                self.removeThreadMessage(chatlog.id);
                self.notifyMemberOfDelete(chatlog.id);
            }).catch(function (error) {
                var data = error.response && error.response.data;
                self.messageActionError = (data && data.message) ? data.message : "The message could not be deleted.";
            });
        },
        updatetValue(value) {
            //this.files = value;
        },
        /**
         * Has changed
         * @param  Object|undefined   newFile   Read only
         * @param  Object|undefined   oldFile   Read only
         * @return undefined
         */
        inputFile: function(newFile, oldFile) 
        {

            
            this.prepareButtons();

            if (newFile && oldFile && !newFile.active && oldFile.active) 
            {
                if (newFile.xhr) {
                    if ( newFile.xhr.status === 200 && newFile.response && newFile.response.success) 
                    {
                        //Add to the $ref='folderComponent' - uploader/show.blade.php
                        let file = [{
                                    'id'        : newFile.response.id,
                                    'file_name' : newFile.response.file,
                                    'size'      : newFile.response.size,
                                }]


                        // let files = this.$root.$refs.folderComponent.files.push(...file);
                        //console.log("file uploaded " + newFile.response.image)


                        var currentTime = new Date();
                        let time = currentTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })

                        //get the sender from props  (admin)
                        let sender = {
                            'msgCtr': 0,
                            'userid': this.userid,
                            'nickname': this.nickname,
                            'username': this.username,          
                            'message': newFile.response.image,
                            'user_image': "https://mypage.mytutor-jpn.com/storage/user_images/noimage.jpg", //no image for sending image (optional)
                            'type': "CHAT_SUPPORT"
                        };
                    
                        this.chatlogs.push({
                            sender: sender,
                            message: newFile.response.image,
                            time: time,
                            sentAt: new Date().toISOString()
                        });

                        this.$forceUpdate(); 
                      

                        //get the sender from props (user)                        
                        let id = newFile.response.id

                        let recipient = {
                            'id': newFile.response.id,
                            'userid': newFile.response.recipient_id,
                            'username': newFile.response.recipient_username,
                        };

                        this.$socket.emit("SEND_USER_MESSAGE", { id, time, recipient, sender });   


                        //get the sender from props (user)
                        let broadcast_recipient = {
                            'id': this.id,
                            'userid': this.userid,
                            'username':  this.username,
                        };


                        //get the sender from props  (admin)
                        let broadcast_sender = {
                            'msgCtr': 0,
                            'userid': this.current_user.userid,
                            'nickname': this.current_user.nickname,
                            'username': this.current_user.username,          
                            'message': this.message,
                            'user_image': this.current_user.user_image, //@todo: make this for customer support 
                            'type': "CHAT_SUPPORT"
                        };

                        this.$socket.emit("SEND_OWNER_MESSAGE", { id, time, broadcast_recipient, broadcast_sender }); 

                    } else {
                        this.sendError = "The file was not saved, so it was not sent. Please try again.";
                    }
                }
            }

            if (this.$refs.upload.uploaded) {
               // console.log("all queue uploaded");
                this.files = [];

                this.scrollToEnd();
            }
        },
        /**
         * Pretreatment
         * @param  Object|undefined   newFile   Read and write
         * @param  Object|undefined   oldFile   Read only
         * @param  Function           prevent   Prevent changing
         * @return undefined
         */
        inputFilter: function(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|gif|png|webp|pdf|doc|docx)$/i.test(newFile.name)) {
                return prevent();
                }
            }


            if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                // Create a blob field
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
                }
                // Thumbnails
                newFile.thumb = ''
                if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                newFile.thumb = newFile.blob
                }
            }
        },

  	},
	computed: {
        chatUsers: function () {
            return this.users.filter(user => user.userid !== this.userid && (user.totalMsg > 0 || user.supportMsg > 0));
        },
        visibleUsers: function () {
            return this.chatUsers.slice(0, this.userListLimit);
        },
        latestEditableId: function () {
            return this.latestRecentSupportId(this.editClock);
        },
        latestDeletableId: function () {
            return this.latestSupportId();
        },
        userListCountLabel: function () {
            var format = function (value) {
                var number = Number(value);
                if (!isFinite(number) || number < 0) {
                    number = 0;
                }
                return Math.floor(number).toLocaleString('en-US');
            };
            if (this.userListTotal === null) {
                return 'Loading chats';
            }
            return format(this.visibleUsers.length) + ' of ' + format(this.userListTotal) + ' chats';
        },
    },
	updated: function () {},
	mounted: function () 
    {
        this.enterAdminChat();

        this.windowStatus = "FOCUSED";
        this.TabTitle =  document.title;

        window.addEventListener("keyup", (e) =>
        {
            this.prepareButtons();       
        });


        window.addEventListener("focus", (e) => {
            this.windowStatus = "FOCUSED";
            if (this.current_user) {
                this.clearUnreadAttention(this.current_user.userid);
            }
        });


        window.addEventListener("blur", (e) => {
            this.windowStatus = "BLURRED";
        });
       
        $(document).on('keydown', '#message', (event) => {        
            if (event.which === 13 && event.shiftKey) {
                //event.preventDefault();            
                //console.log("Shift + Enter pressed!");
            } else if (event.which === 27 && this.editingMessageId) {
                this.cancelEditMessage();
                event.preventDefault();
            } else if (event.which === 13) {
                this.sendMessage();
                event.preventDefault();
            }
        });
          
        this.appendRecentUserChatList(this.onlineUsers) ;
        var self = this;
        this.editClockTimer = setInterval(function () {
            self.editClock = Date.now();
        }, 15000);
    },
    beforeDestroy: function () {
        this.clearUserListFillTimer();
        if (this.editClockTimer) {
            clearInterval(this.editClockTimer);
            this.editClockTimer = null;
        }
        this.stopBlink();
        this.stopAdminTyping();
    },
};


Vue.component("chatlogs-component", {
  props: ['chatlogs', 'latestMessageId', 'latestDeletableId', 'now', 'editingId'],
  data: function () {
    return {};
  },
  methods: {
    adminChat() {
        var root = this.$root;
        if (root && root.$refs && root.$refs.adminChatComponent) {
            return root.$refs.adminChatComponent;
        }
        return null;
    },
    isEditing(chatlog) {
        return !!(chatlog && this.editingId !== null && this.editingId !== undefined && String(chatlog.id) === String(this.editingId));
    },
    showManage(chatlog) {
        if (!chatlog || chatlog.id === undefined || chatlog.id === null || chatlog.id === "") {
            return false;
        }
        if (!chatlog.sender || chatlog.sender.type !== "CHAT_SUPPORT") {
            return false;
        }
        if (this.latestMessageId === null || this.latestMessageId === undefined || String(chatlog.id) !== String(this.latestMessageId)) {
            return false;
        }
        var sent = this.parseChatDate(chatlog.sentAt || chatlog.time);
        if (!sent) {
            return false;
        }
        var now = Number(this.now) || Date.now();
        return now - sent.getTime() < 5 * 60 * 1000;
    },
    showDelete(chatlog) {
        return this.showManage(chatlog);
    },
    startEdit(chatlog) {
        var parent = this.adminChat();
        if (parent) {
            parent.startEditMessage(chatlog);
        }
    },
    removeMessage(chatlog) {
        var parent = this.adminChat();
        if (parent) {
            parent.deleteThreadMessage(chatlog);
        }
    },
    prependHTTPS(url) {
        if (!/^https?:\/\//i.test(url)) {
            url = 'https://' + url;
            return url;
        } else {

            return url;
        }
    },
    formatMessage(message) 
    {
       if (message === null || message === undefined) {
           return '';
       }
       return this.urlify(String(message));
    },
    parseChatDate(value) {
        if (!value) {
            return null;
        }
        var date = new Date(value);
        if (isNaN(date.getTime())) {
            return null;
        }
        return date;
    },
    chatClock(chatlog) {
        var date = this.parseChatDate(chatlog.sentAt || chatlog.time);
        if (!date) {
            return '';
        }
        var hours = date.getHours();
        var minutes = date.getMinutes();
        return (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
    },
    chatDayLabel(chatlog) {
        var date = this.parseChatDate(chatlog.sentAt || chatlog.time);
        if (!date) {
            return '';
        }
        var weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return weekdays[date.getDay()] + ', ' + months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
    },
    showChatDay(index) {
        var label = this.chatDayLabel(this.chatlogs[index]);
        if (!label) {
            return false;
        }
        if (index === 0) {
            return true;
        }
        return label !== this.chatDayLabel(this.chatlogs[index - 1]);
    },
    linkify_v1(str) {
       return str.replace(/((http(s)?(\:\/\/))?(www\.)?([\w\-\.\/])*(\.[a-zA-Z]{2,3}\/?))(?!(.*a>)|(\'|\"))/g, '<a href="$1"  target="_blank" >$1</a>');    
    },
    linkify(text) {

        // Create a temporary DOM element
        var tempElement = document.createElement('div');
        tempElement.innerHTML = text;

        // Get all text nodes within the temporary DOM element
        var textNodes = [];
        var treeWalker = document.createTreeWalker(tempElement, NodeFilter.SHOW_TEXT, null, false);
        while (treeWalker.nextNode()) {
            textNodes.push(treeWalker.currentNode);
        }

        // Replace URLs with anchor tags in text nodes
        textNodes.forEach(function(node) {
            var nodeText = node.nodeValue;
            var urlRegex = /((http|https|ftp):\/\/[^\s]+)/g;
            var replacedText = nodeText.replace(urlRegex, function(url) {
            // Exclude anchor tags, img tags, href links, and text inside img tags
            if (node.parentNode.tagName !== 'A' && node.parentNode.tagName !== 'IMG' && node.parentNode.getAttribute('href') !== url && node.parentNode.getAttribute('src') !== url) {
                return '<a href="' + url + '" target="_blank">' + url + '</a>';
            } else {
                return url;
            }
            });
            if (replacedText !== nodeText) {
            var newNode = document.createElement('span');
            newNode.innerHTML = replacedText;
            node.parentNode.replaceChild(newNode, node);
            }
        });

        return tempElement.innerHTML;
    },
    urlify(text) {
        var addHTTPsExp = /(\b((https?|ftp|file):\/\/|(www))[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]*)/ig;   
        let newString = text.replace(addHTTPsExp, (url) => {
           let newLink = this.prependHTTPS(url);
           return newLink;
        });
        return  this.linkify(newString);
    },
  },
  template:
    `<div class="admin-chat-thread">
        <div v-for="(chatlog, chatlogIndex) in chatlogs" :key="chatlog.id ? ('chatlog_' + chatlog.id) : ('chatlog_' + chatlogIndex)">
            <div v-if="showChatDay(chatlogIndex)" class="admin-chat-day">{{ chatDayLabel(chatlog) }}</div>

            <div v-if="chatlog.sender.type == 'MEMBER'" class="admin-chat-msg">
                <img v-if="chatlog.sender.user_image" :src="chatlog.sender.user_image" class="admin-chat-avatar is-photo member-image" alt="">
                <span v-else class="admin-chat-avatar"><i class="fas fa-user"></i></span>
                <div class="admin-chat-body">
                    <div class="admin-chat-bubble member-message" v-html="formatMessage(chatlog.sender.message)"></div>
                    <div class="admin-chat-time">{{ chatClock(chatlog) }}</div>
                </div>
            </div>

            <div v-if="chatlog.sender.type == 'CHAT_SUPPORT'" class="admin-chat-msg is-support">
                <span class="admin-chat-avatar"><i class="fas fa-headset"></i></span>
                <div class="admin-chat-body">
                    <div class="admin-chat-bubble chatsupport-message" v-html="formatMessage(chatlog.sender.message)"></div>
                    <div class="admin-chat-time">Support · {{ chatClock(chatlog) }}</div>
                    <div v-if="(showManage(chatlog) || showDelete(chatlog)) && !isEditing(chatlog)" class="admin-chat-manage">
                        <button v-if="showManage(chatlog)" type="button" class="admin-chat-action" @click="startEdit(chatlog)">Edit</button>
                        <button v-if="showDelete(chatlog)" type="button" class="admin-chat-action is-danger" @click="removeMessage(chatlog)">Delete</button>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    ,
});




Vue.component("current-user-component", {
  props: ['user'],
  data: function () {
    return {};
  },
  methods: {
    closeChat() {
        //this.$parent.hideChatBox()
        this.$root.$refs["adminChatComponent"].hideChatBox()
    }
  },
  template:
    `<div class="card-header admin-chat-heading">
        <img v-if="user.user_image" :src="user.user_image" class="admin-chat-heading-photo member-image" alt="">
        <div class="admin-chat-heading-text">
            <div class="h5 mb-0">{{ user.nickname}}</div>
            <div class="small">{{  user.username }}</div>
            <div class="admin-presence" :class="user.status == 'online' ? 'is-online' : 'is-offline'">{{ user.status == 'online' ? 'Online' : 'Offline' }}</div>
            <div class="small">ID Number: {{ user.userid }}</div>
        </div>

        <div class="admin-chat-heading-close">          
            <button v-on:click="closeChat()" style="border:none">X</button>
        </div>
    </div>`
    ,    
});





Vue.component("member-info-component", {
  props: ['image', 'nickname', 'time'],
  data: function () {
    return {};
  },
  template:
    `<div style='text-align:left'>      
      <span class="pl-3 small">{{ nickname }}</span>
      <img :src="image" class="img-fluid member-image" width="50"  style='float:left; border-radius:50%'/> 
    </div>`
    ,    
});


Vue.component("chatsupport-info-component", {
  props: ['image', 'nickname', 'time'],
  data: function () {
    return {};
  },
  template:
    `<div style='text-align:right'>      
      <span class="pl-3 small">{{ nickname }}</span>
    </div>`
    ,    
});

</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.img_preview {
    width: 100px;
    cursor: pointer;
}
.admin-image-preview {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    background: rgba(0, 0, 0, 0.5);
    outline: none;
}
.admin-image-preview-dialog {
    flex: 0 1 auto;
    width: fit-content;
    max-width: min(1140px, calc(100vw - 1rem));
    min-width: 0;
}
.admin-image-preview-frame {
    width: fit-content;
    max-width: 100%;
    min-width: min(360px, calc(100vw - 1rem));
    background: rgba(15, 23, 42, 0.96);
    border-radius: 10px;
    overflow: hidden;
    color: #fff;
}
.admin-image-preview-bar {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 10px 8px 16px;
    font-size: 13px;
    color: #fff;
}
.admin-image-preview-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 600;
}
.admin-image-preview-count {
    flex-shrink: 0;
    font-size: 12px;
    opacity: 0.7;
}
.admin-image-preview-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    margin: 0;
    border: 0;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    font-size: 15px;
    line-height: 1;
    padding: 0;
    cursor: pointer;
    text-decoration: none;
}
.admin-image-preview-btn.is-open {
    margin-left: auto;
}
.admin-image-preview-btn:hover,
.admin-image-preview-btn:focus {
    background: rgba(255, 255, 255, 0.22);
    color: #fff;
    text-decoration: none;
}
.admin-image-preview-stage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px 12px;
}
.admin-image-preview-img {
    display: block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: calc(100vh - 140px);
    object-fit: contain;
    border-radius: 6px;
}
.admin-image-preview-nav {
    position: absolute;
    top: 50%;
    z-index: 1;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border: 0;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
    font-size: 20px;
    cursor: pointer;
}
.admin-image-preview-nav:hover {
    background: rgba(0, 0, 0, 0.7);
}
.admin-image-preview-nav.is-prev {
    left: 18px;
}
.admin-image-preview-nav.is-next {
    right: 18px;
}
@media (max-width: 575.98px) {
    .admin-image-preview-img {
        max-height: calc(100vh - 110px);
    }
}
.custom-pdf {
    font-size: 100px;
}
</style>


<style>
.floating-history-fetcher {
    position: absolute;
    top: 65px;
    display: inline-block;    
    text-align: center;
    width: 100%;
    z-index: 99;
}

.memberlist-panel .card-header {
  background-color: #35bbeb;
  border: #35bbeb;
  font-weight: bold;
  color: #fff;
}

.memberlist-panel .card-body {
  padding: 0px;
}

.memberlist-panel.card {
  display: flex;
  flex-direction: column;
}

.memberlist-panel .card-body {
  height: 536px;
  max-height: 536px;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.memberlist-panel .user-list-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex: 0 0 auto;
  padding: 8px 10px;
  text-align: center;
  background: #fff;
  border-top: 1px solid #e6eef2;
}

.admin-chat-loader {
  cursor: default;
  white-space: nowrap;
}

.memberlist-panel .user-list-count {
  font-size: 12px;
  line-height: 1.2;
  color: #8a969c;
}

@media (prefers-reduced-motion: reduce) {
  .admin-chat-loader .fa-spin {
    animation: none;
  }
}

.user-info { 
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 8px 8px 8px 3px; border-bottom:1px solid rgb(236, 236, 236);
    cursor: pointer;
}

.user-info:hover { 
    background-color: #e1f6fd;
}

.user-info.active { 
    background-color: #b8ebfc;
}

.member .profile-photo img {
    border-radius: 50%;
}

.member-image {
  border:1px solid #ccc;
}

.member-message {
  margin: 0;
}

/*chatbox styles */
.chatbox-info-heading {
   background-color: #fff;
   border-bottom: 1px solid #ccc
}

.chatsupport-image {
  float: left;
}

#user-chatlog, .loading-container, .admin-chat-log {
  height: 420px;
  max-height: 420px;
  padding: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: #f4f7fa;
  border: 0;
  border-radius: 0;
}
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-chat-send-error {
  flex: 0 0 auto;
  margin: 0 0 8px;
  padding: 6px 10px;
  border-radius: 8px;
  background: #fde8e8;
  color: #9b1c1c;
  font-size: 12px;
  line-height: 1.4;
}
.admin-chat-unread-separator {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0;
  color: #c0392b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.admin-chat-unread-separator::before,
.admin-chat-unread-separator::after {
  content: "";
  flex: 1 1 auto;
  height: 1px;
  background: #e07a72;
}
.admin-chat-older {
  text-align: center;
  margin-bottom: 12px;
}
.admin-chat-older-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #d8dee6;
  background: #fff;
  color: #5c6b7a;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.2;
  padding: 6px 12px;
  cursor: pointer;
}
.admin-chat-older-btn:hover {
  background: #f7fafc;
  color: #1f6fb5;
}
.admin-chat-older .admin-chat-loader {
  cursor: default;
}
.admin-chat-day {
  text-align: center;
  font-size: 11px;
  color: #999;
  margin: 4px 0 10px;
}
.admin-chat-msg {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-bottom: 10px;
}
.admin-chat-msg.is-support {
  flex-direction: row-reverse;
}
.admin-chat-body {
  max-width: 78%;
  min-width: 0;
}
.admin-chat-avatar {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border-radius: 50%;
  background: #3eaee6;
  color: #fff;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}
img.admin-chat-avatar.is-photo {
  object-fit: cover;
  background: #e8eef3;
  display: block;
}
.admin-chat-heading {
  display: flex;
  align-items: center;
  gap: 10px;
}
.admin-chat-heading-text {
  flex: 1 1 auto;
  min-width: 0;
}
.admin-chat-heading-close {
  margin-left: auto;
}
.admin-chat-heading-photo {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 50%;
  object-fit: cover;
  background: #e8eef3;
}
.admin-chat-bubble {
  background: #fff;
  border: 1px solid #d8dee6;
  border-radius: 14px 14px 14px 4px;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.5;
  color: #243140;
  overflow: hidden;
  overflow-wrap: anywhere;
  max-width: 100%;
}
.admin-chat-bubble a.img_preview {
  display: block;
  width: auto;
  max-width: 100%;
}
.admin-chat-bubble img,
.admin-chat-bubble img.img_preview,
.admin-chat-bubble.member-message img.img_preview,
.admin-chat-bubble.chatsupport-message img.img_preview,
.admin-chat-bubble .img_preview {
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 240px;
  border-radius: 8px;
  box-sizing: border-box;
  cursor: zoom-in;
}
.admin-chat-msg.is-support .admin-chat-bubble {
  background: #2f8fd8;
  border-color: #2f8fd8;
  color: #fff;
  border-radius: 14px 14px 4px 14px;
}
.admin-chat-msg.is-support .admin-chat-bubble a {
  color: #fff;
}
.admin-chat-time {
  font-size: 10px;
  color: #999;
  margin-top: 2px;
}
.admin-chat-msg.is-support .admin-chat-time {
  text-align: right;
}
.admin-chat-msg.is-unsent .admin-chat-bubble.is-failed {
  background: #fde8e8;
  border-color: #e7b4b4;
  color: #7a1f1f;
}
.admin-chat-unsent,
.admin-chat-manage {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  font-size: 11px;
}
.admin-chat-unsent {
  color: #9b1c1c;
}
.admin-chat-action,
.admin-chat-resend {
  border: 0;
  background: transparent;
  padding: 0;
  color: #1f6fb5;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}
.admin-chat-action.is-muted {
  color: #6b7780;
  font-weight: 600;
}
.admin-chat-action.is-danger,
.admin-chat-resend {
  color: #b42318;
}
.admin-chat-resend:disabled,
.admin-chat-discard:disabled {
  opacity: 0.6;
  cursor: default;
}
.admin-chat-discard {
  border: 0;
  background: transparent;
  padding: 0;
  color: #6b7780;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.admin-presence {
  font-size: 11px;
  line-height: 1.3;
  font-weight: 600;
}
.admin-presence:before {
  content: "";
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-right: 4px;
  border-radius: 50%;
  background: currentColor;
  vertical-align: 1px;
}
.admin-presence.is-online {
  color: #1f9d55;
}
.admin-presence.is-offline {
  color: #8a969c;
}

.profile-photo {
  width: 42px;
  height: 42px;
  display: inline-block;
  overflow: hidden;
  border-radius: 50%;
  vertical-align: top;
}
.user-list-photo {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  background: #e8eef3;
}

.profile-user-info {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
}
.user-list-email {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}
.user-list-email .username {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-list-date {
  flex: 0 0 auto;
  margin-left: auto;
  font-size: 11px;
  line-height: 1.2;
  color: #8a969c;
  white-space: nowrap;
}
.user-list-recent {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.user-list-recent span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-list-recent i {
  flex: 0 0 auto;
  color: #9aa3ab;
  font-size: 12px;
}


.chatsupport-message {
  margin: 0;
}



#user-chatlog::-webkit-scrollbar,
.memberlist-panel .card-body::-webkit-scrollbar {
  width: 8px;
}
#user-chatlog::-webkit-scrollbar-track,
.memberlist-panel .card-body::-webkit-scrollbar-track {
  background: transparent;
}
#user-chatlog::-webkit-scrollbar-thumb,
.memberlist-panel .card-body::-webkit-scrollbar-thumb {
  background: #c5d0d8;
  border-radius: 8px;
}
#user-chatlog::-webkit-scrollbar-thumb:hover,
.memberlist-panel .card-body::-webkit-scrollbar-thumb:hover {
  background: #8aa0ad;
}  


#floating-history-btn {
    font-size: 11px;
}
 

.btn-xs {
    font-size: 11px;
    padding: 2px 5px 2px;
}

.hr-center {
    display: flex;
    flex-basis: 100%;
    align-items: center;
    color: rgba(0, 0, 0, 0.35);
    margin: 8px 0px;
}
.hr-center:before,
.hr-center:after {
    content: "";
    flex-grow: 1;
    background: rgba(0, 0, 0, 0.35);
    height: 1px;
    font-size: 0px;
    line-height: 0px;
    margin: 0px 8px;
}

#attached-progress-report {
    width: 100%;
}



#multiselect-members { 
    font-size: 14px;
}

.multiselect__option {
    font-size: 14px;
}


.multiselect__placeholder {
    font-size: 14px;
}


.admin-chat-composer {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    margin-top: 8px;
    padding: 6px;
    background: #fff;
    border: 0;
    border-radius: 0;
}
.admin-chat-composer-actions {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    flex: 0 0 auto;
    gap: 6px;
}
.admin-chat-composer .text-message-container,
.text-message-container {
    float: none;
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
    margin: 0;
}
.admin-chat-composer .auto-expand,
.auto-expand {
    resize: none;
    width: 100%;
    min-height: 25px;
    margin: 0;
    padding: 5px 8px;
    height: 30px;
    line-height: 15px;
    border: 1px solid #b7d4ea;
    border-radius: 6px;
    background: #fff;
    box-shadow: none;
}
.admin-chat-composer .auto-expand:focus {
    border: 1px solid #b7d4ea;
    box-shadow: none;
    outline: none;
}
.admin-chat-composer-actions #attach-button,
.admin-chat-composer-actions #send-button {
    flex: 0 0 auto;
    margin: 0;
}
.admin-chat-cancel-edit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 35px;
    margin: 0;
    padding: 0 12px;
    border: 1px solid #2f8fd8;
    border-radius: 6px;
    background: #fff;
    color: #1f6fb5;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
}
.admin-chat-cancel-edit:hover,
.admin-chat-cancel-edit:focus {
    background: #e8f4fc;
    border-color: #1f6fb5;
    color: #174f86;
    outline: none;
}
.admin-chat-cancel-edit i {
    font-size: 12px;
}
</style>

<style scoped>
.icon-label-container {
    display: block;
    width: 35px;
    height: 35px;    
}

.icon-label-btn {
    font-size: 18px;
    position: absolute;
    left: 23.5%;
    top: 20%;    
}
</style>